/*
 * @Descripttion:
 * @Author: Yi Yunwan
 * @Date: 2021-03-29 14:15:54
 * @LastEditors: Yi Yunwan
 * @LastEditTime: 2021-03-30 20:39:39
 */
import { Vue, point } from '@/common/base'
import App from './App.vue'
import router from './router'
import store from '@/store'
import './styles/index.scss'
import VueI18n from 'vue-i18n'
import '../../common/utils/JSMath'
import { getAppLanguage } from '@/common/utils'
// Vue.use(report)
// Vue.use(pageReport)
Vue.prototype.$point = point
Vue.use(VueI18n)
//const lang = getQueryVariable('language') as string
const lang = getAppLanguage()
const i18n = new VueI18n({
  locale: lang ? lang : 'zh_CN',
  messages: {
    zh_CN: require('../../lang/zh.json')
  }
})

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
